import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class stationListEventService {
    invokeListSelection = new EventEmitter();
    subsVar: Subscription;
    constructor() { }

    onlistSelection(maetpunktId:number) {
        this.invokeListSelection.emit(maetpunktId);
    }
}
